/**
 * Main App component
 * Handles routing and global app structure with authentication
 * Context: LostMind AI Video Lab main application shell
 */

import { Routes, Route } from 'react-router-dom';
import { AppShell } from '@mantine/core';

// Pages
import LandingPage from './pages/index';
import DashboardPage from './pages/dashboard';
import LabPage from './pages/lab';

// Layout components
import Navbar from './components/layout/Navbar';

// Auth components
import { AuthProvider } from './components/auth/AuthProvider';
import { ProtectedRoute } from './components/auth/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <AppShell header={{ height: 70 }} padding="md">
        <Navbar />
        <AppShell.Main>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/lab" 
              element={
                <ProtectedRoute>
                  <LabPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/lab/:projectId" 
              element={
                <ProtectedRoute>
                  <LabPage />
                </ProtectedRoute>
              } 
            />
          </Routes>
        </AppShell.Main>
      </AppShell>
    </AuthProvider>
  );
}

export default App;